<div class="lastResultInnerWrap">
   <div class="title">
      <div class="label">{{'dge.lst_res' | translate}}</div>
      <div class="dateWrap">
         <span class="lbl">{{'dge.date' | translate}}: </span>
         <span class="date">{{gameData?.lastDrawWinningResultVOs[0]?.lastDrawDateTime | date:'d/MM/yyyy'}}</span>
      </div>
   </div>
   <div class="lt-resultWrap" *ngIf="gameCode == 'ThaiLottery' || gameCode == 'ThaiLotteryHighFrequency'">
      <div class="blk">
         <div class="up-box">
            <div class="label">{{'dge.1st_prz' | translate}}</div>
            <!-- <div class="cat" innerHTML="{{'dge.Category1' | translate}}"> -->
            <!-- 1<sup>st</sup> {{'dge.cat' | translate}} -->
            <!-- </div> -->
         </div>
         <div class="dw-box">
            <div class="value">{{getLastDrawResult(0)}}{{getLastDrawResult(1)}}</div>
         </div>
      </div>
      <div class="blk">
         <div class="up-box">
            <div class="label">{{'dge.1st_3' | translate}}</div>
            <!-- <div class="cat" innerHTML="{{'dge.Category2' | translate}}"> -->
            <!-- 2<sup>nd</sup> {{'dge.cat' | translate}} -->
            <!-- </div> -->
         </div>
         <div class="dw-box">
            <div class="value">{{getLastDrawResult(2)}}/{{getLastDrawResult(3)}}</div>
         </div>
      </div>
      <div class="blk">
         <div class="up-box">
            <div class="label">{{'dge.lst_3' | translate}}</div>
            <!-- <div class="cat" innerHTML="{{'dge.Category3' | translate}}"> -->
            <!-- 3<sup>rd</sup> {{'dge.cat' | translate}} -->
            <!-- </div> -->
         </div>
         <div class="dw-box">
            <div class="value">{{getLastDrawResult(4)}}/{{getLastDrawResult(5)}}</div>
         </div>
      </div>
      <div class="blk">
         <div class="up-box">
            <div class="label">{{'dge.2_dig' | translate}}</div>
            <!-- <div class="cat" innerHTML="{{'dge.Category4' | translate}}"> -->
            <!-- 4<sup>th</sup> {{'dge.cat' | translate}} -->
            <!-- </div> -->
         </div>
         <div class="dw-box">
            <div class="value">{{getLastDrawResult(6)}}</div>
         </div>
      </div>
   </div>
   <div class="lt-resultWrap" *ngIf="gameCode == 'TwoDMYANMAAR'">
      <div class="blk">
         <div class="up-box">
            <div class="label">{{'dge.am' | translate}}</div>
         </div>
         <div class="dw-box">
            <div class="value">{{lastDrawResult[0]?.am[0]}}
            </div>
         </div>
      </div>
      <div class="blk">
         <div class="up-box">
            <div class="label">{{'dge.pm' | translate}}</div>
         </div>
         <div class="dw-box">
            <div class="value">{{lastDrawResult[0]?.pm[0]}}
            </div>
         </div>
      </div>
   </div>
   <div class="lt-resultWrap" *ngIf="gameCode == 'BichoRapido'">
      <div class="blk" *ngFor="let item of lastDrawResult; let j = index">
         <div class="up-box">
            <div class="label">Reel {{j+1}}</div>
            <div class="cat">{{lastDrawResultName[j]}}</div>
         </div>
         <div class="dw-box">
            <div class="value">{{item}}</div>
         </div>
      </div>
   </div> 
   <div class="lt-resultWrap" *ngIf="gameCode == 'MiniRoulette'">
      <div class="results">
          <div class="minirou-results-number">
              <ul>
                  <li class="bx{{gameData?.matchedWinningColor}}"> <span class="draw_number">{{gameData?.lastDrawWinningResultVOs[0]?.winningNumber}}</span> <span class="draw_time">{{gameData?.lastDrawWinningResultVOs[0]?.lastDrawDateTime | date:'HH:mm'}}</span> </li>
              </ul>
          </div>
      </div>
  </div>    
</div>
<div class="lastResultInnerWrap extended-results" *ngIf="gameCode == 'TwoDMYANMAAR'">
   <div class="title">
      <div class="label">{{'dge.rec_res' | translate}}</div>
   </div>
   <div class="lt-resultWrap">
      <ng-container *ngFor="let result of lastDrawResult; let resIndex = index;">
         <div class="blk" *ngIf="resIndex < 2">
            <div class="box date-box">
               <div class="label">{{result?.date | date:'EEE - d/MM/yyyy'}}
               </div>
            </div>
            <div class="box am-box">
               <div class="value">{{result?.am[0]}}<span class="meridiem">{{'dge.am' | translate}}</span>
               </div>
            </div>
            <div class="box pm-box">
               <div class="value">{{result?.pm[0]}}<span class="meridiem">{{'dge.pm' | translate}}</span>
               </div>
            </div>
         </div>
      </ng-container>
   </div>
</div>      
                                